<template>
    <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 6.87554C6.68023 6.79168 6.36558 6.66885 6.06277 6.50519C4.98669 5.92359 4.01052 4.95511 3.76156 3.87449C3.54961 2.95449 3.93904 1.95053 4.44407 1.06369C4.64374 0.713067 4.88992 0.403367 5.17107 0.137769C3.38701 -0.330123 1.44386 0.414989 0.512554 2.05038C-0.585677 3.97889 0.139041 6.41513 2.13126 7.49188C3.76127 8.37286 5.73475 8.07079 7 6.87554Z" fill="currentColor"/>
    </svg>
</template>
